import { Card, CardContent } from "@mui/material"
import { IModelMetaDataCard } from "../../util/interface"
import { createUseStyles, useTheme } from "react-jss"
import { ErrorBoundary } from "react-error-boundary"
import { CustomErrorMsg } from "../../components/CustomErrorMsg"

const useStyles = createUseStyles({
  wrapper: {
    fontFamily: ({ theme }: any) => theme.primaryFontFamily,
    display: "flex",
    flexDirection: "column",
    gap: 9,
  },
  headerWrapper: {
    display: "grid",
    alignItems: "center",
    justifyContent: "center",
    height: 30,
    textAlign: "center",
  },
  header: {
    fontSize: "16px",
    fontWeight: 700,
    lineHeight: "19.5px",
    letterSpacing: "0.1em",
    color: "#5C5C5C",
    textAlign: "center",
  },
  bodyWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 9,
  },
  note: {
    fontSize: "10px",
    fontWeight: 500,
    lineHeight: "12.19px",
    letterSpacing: "0.1em",
    textAlign: "left",
    color: "#7D7D7D",
  },
  percentage: {
    fontSize: "32px",
    fontWeight: 700,
    lineHeight: "39.01px",
    letterSpacing: "0.1em",
    textAlign: "left",
    color: "#27AF8D",
  },
})
export const ModelMetaDataCard = ({
  cardDetails,
  activeTab,
}: {
  cardDetails: IModelMetaDataCard
  activeTab: string
}) => {
  const theme: any = useTheme()

  const classes = useStyles({ theme })

  return (
    <ErrorBoundary fallback={<CustomErrorMsg />}>
      <Card
        sx={{
          minWidth: 200,
          minHeight: 100,
          // padding: 0.5,
          boxShadow:
            activeTab == cardDetails.key
              ? "0px 4px 8px 0px #25d4cf4D"
              : "0px 2px 4px 0px #00000040",
          border:
            activeTab == cardDetails.key
              ? "2px solid #25d4cf66"
              : "2px solid #fff",
          cursor: "pointer",
        }}
      >
        <CardContent sx={{ paddingTop: 1.1 }}>
          <div className={classes.wrapper}>
            <div className={classes.headerWrapper}>
              <h3 className={classes.header}> {cardDetails.title} </h3>
            </div>
            <div className={classes.bodyWrapper}>
              <div className={classes.percentage}>
                {Number(cardDetails.percentage).toFixed(2)}%
              </div>
              <div className={classes.note}>
                Before Retraining:
                {Number(cardDetails.retrainingPercentage).toFixed(2)}%
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </ErrorBoundary>
  )
}
